<template>
  <div class="welcome">
    <div class="welcome__card">
      <div class="welcome__card-text">
        <div class="welcome__title">Институт экономики и <br/> управления АПК</div>
        <div class="welcome__hint">Приемная кампания 2025</div>
      </div>
    </div>
  </div>
</template>


<style scoped>
.welcome {
  height: 800px;
  background-image: url('../../assets/background.png');
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.welcome__card {
  max-width: 910px;
  max-height: 423px;
  width: 100%;
  height: 100%;
  background-image: url('data:image/svg+xml,<svg width="910" height="423" viewBox="0 0 910 423" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M863.074 90.029C750.521 20.9927 593.873 121.122 447.632 70.5302C289.618 15.8658 130.224 -60.1646 39.3027 78.9622C-51.6185 218.089 13.7396 475.312 250.722 413.604C505.727 347.203 658.088 445.923 792.684 389.742C891.273 362.339 960.389 149.719 863.074 90.029Z" fill="white" fill-opacity="0.64"/></svg>'); 
}
.welcome__card-text {
  padding: 107px 30px 76px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;
}
.welcome__title {
  font-weight: 700;
  font-size: 48px;
  line-height: 90px;
  text-align: center;
}
.welcome__hint {
  font-weight: 500;
  font-size: 32px;
  line-height: 28px;
}
@media (max-width: 500px) {
  .welcome__title {
    font-size: 32px; 
    line-height: 50px;
  }
  .welcome__hint {
    font-size: 24px;
    line-height: 25px;
  }
}
</style>